import { useSearchParams } from 'next/navigation';
import { useState } from 'react';

export function useTabUrlSync<T extends string>(paramName: string, validValues: readonly T[], defaultValue: T) {
    const searchParams = useSearchParams();

    const [tab, setTab] = useState<T>(() => {
        const initialValue = searchParams.get(paramName);

        if (initialValue && (validValues as readonly string[]).includes(initialValue)) {
            return initialValue as T;
        }

        return defaultValue;
    });

    function updateTab(value: T) {
        setTab(value);

        const newUrl = new URL(window.location.href);
        if (value === defaultValue) {
            newUrl.searchParams.delete(paramName);
        } else {
            newUrl.searchParams.set(paramName, value);
        }

        history.replaceState(null, '', newUrl);
    }

    return [tab, updateTab] as const;
}
